import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="administration--profile-change-requests--toggle-batch-actions"
export default class extends Controller {
  connect() {
    this.toggleCheckboxListener = () => this.toggle();
    this.checkboxes = this.element.querySelectorAll(
      'input[name="profile_change_request_select"]',
    );
    this.checkboxes.forEach((checkbox) =>
      checkbox.addEventListener("change", this.toggleCheckboxListener),
    );
    this.toggle();
  }

  disconnect() {
    this.checkboxes.forEach((checkbox) =>
      checkbox.removeEventListener("change", this.toggleCheckboxListener),
    );
  }

  toggle() {
    const anyChecked =
      this.element.querySelectorAll(
        'input[name="profile_change_request_select"]:checked',
      ).length > 0;

    this.element
      .querySelector(".batch_processing-actions")
      .classList.toggle("hidden", !anyChecked);
  }
}
